import React from 'react';
import { ProjectId } from '../../../../../../models/Types';
import IncomingInvoicesDrawerControllingStep from '../drawerSteps/IncomingInvoicesDrawerControllingStep';
import IncomingInvoicesDrawerDataStep from '../drawerSteps/IncomingInvoicesDrawerDataStep';
import { IncomingInvoicesDrawerOverviewStep } from '../drawerSteps/IncomingInvoicesDrawerOverviewStep';
import { IncomingInvoiceDto } from '../../../../../../models/IncomingInvoices';
import IncomingInvoicesDrawerAllocationStep from '../drawerSteps/IncomingInvoicesDrawerAllocationStep';

interface Props {
  currentStep: number;
  projectId: ProjectId;
  netAmount: number;
  invoice: IncomingInvoiceDto | null;
  hasFile: boolean;
  pdfLoading: boolean;
  loadInvoicePdf: () => void;
  onClose: () => void;
  onActionComplete?: () => void;
  skipAllocationStep: boolean;
  allocationStepOptional: boolean;
  mode: 'edit' | 'view' | 'review';
}

export const IncomingInvoiceDrawerSteps: React.FC<Props> = ({
  currentStep,
  projectId,
  netAmount,
  invoice,
  hasFile,
  pdfLoading,
  loadInvoicePdf,
  onClose,
  onActionComplete,
  skipAllocationStep,
  allocationStepOptional,
  mode,
}) => {
  return (
    <>
      <div style={{ display: currentStep === 0 ? 'block' : 'none' }}>
        <IncomingInvoicesDrawerDataStep
          projectId={projectId}
          invoice={invoice as IncomingInvoiceDto}
          loadInvoicePdf={loadInvoicePdf}
          pdfLoading={pdfLoading}
          hasFile={hasFile}
          onOCRTriggered={() => {
            onClose();
            if (onActionComplete) onActionComplete();
          }}
        />
      </div>

      <div style={{ display: currentStep === 1 ? 'block' : 'none' }}>
        <IncomingInvoicesDrawerControllingStep />
      </div>

      {/* Only render allocation step if user has controller permissions */}
      {!skipAllocationStep && (
        <div style={{ display: currentStep === 2 ? 'block' : 'none' }}>
          <IncomingInvoicesDrawerAllocationStep
            amountToTransfer={netAmount}
            allocationStepOptional={allocationStepOptional}
            mode={mode}
          />
        </div>
      )}

      <div style={{ display: currentStep === 3 ? 'block' : 'none' }}>
        <IncomingInvoicesDrawerOverviewStep
          skipAllocationStep={skipAllocationStep}
        />
      </div>
    </>
  );
};
